import React, { useEffect } from 'react';
import ButtonSeatUpgrade from './ButtonSeatUpgrade';
import ButtonUpgrade from './ButtonUpgrade';
import ButtonTeam from './ButtonTeam';
import ButtonUsers from './ButtonUsers';
import { RbacPermissionType } from '../../../../../types';
import { useActionsQueryLazyQuery } from './Actions.generated';

const ButtonUser = () => {
  const [fetch, { loading, data }] = useActionsQueryLazyQuery();
  useEffect(() => {
    fetch();
  }, []);

  if (loading) return null;
  if (!data?.user) return null;
  const user = data?.user;

  const { team } = user;
  const teamMembership = user.teamMembership ?? {
    isAdmin: false,
    memberType: '',
  };
  const { isAnnual } = user.package ?? {};
  // Non-SSO users requires sm.features.users.invite to access /team/add
  // SSO users requires sm.features.users.view_users to see modal with invitation link under /team/users
  const canAddUsers =
    team?.ssoState === 'REQUIRED'
      ? user.permissions?.includes(RbacPermissionType.UsersView)
      : user.permissions?.includes(RbacPermissionType.UsersInvite);
  const showSeatUpgradeButton =
    user?.features?.powerCasualEnabled &&
    teamMembership.memberType === 'CASUAL';

  if (showSeatUpgradeButton) {
    return <ButtonSeatUpgrade />;
  }
  if (canAddUsers) {
    return <ButtonUsers />;
  }
  if (!team && isAnnual) {
    return <ButtonTeam />;
  }
  if (!team) {
    return <ButtonUpgrade />;
  }
  return null;
};

export default ButtonUser;
